import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { getLegacyProjectTarget } from '@/lib/navigation';

interface LandingEntryRouteProps {
  children: ReactNode;
}

const LandingEntryRoute: React.FC<LandingEntryRouteProps> = ({ children }) => {
  const { search } = useLocation();
  const legacyProjectTarget = getLegacyProjectTarget(search);

  if (legacyProjectTarget) {
    return <Navigate to={legacyProjectTarget} replace />;
  }

  return <>{children}</>;
};

export default LandingEntryRoute;
